(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(list){
    if(list.dataset.ksReady) return; list.dataset.ksReady='1';
    var section=list.closest('.ksiazka-faq');
    var items=Array.prototype.slice.call(list.querySelectorAll('.ksiazka-faq__item'));
    // akordeon
    items.forEach(function(it){
      var q=it.querySelector('.ksiazka-faq__q');
      q.addEventListener('click',function(){ q.setAttribute('aria-expanded', q.getAttribute('aria-expanded')==='true'?'false':'true'); });
    });
    // zakładki
    var tabsWrap=section?section.querySelector('[data-ksiazka-faq-tabs]'):null;
    if(tabsWrap){
      var tabs=Array.prototype.slice.call(tabsWrap.querySelectorAll('.ksiazka-faq__tab'));
      function count(cat){ return items.filter(function(it){ return cat==='all'||it.getAttribute('data-cat')===cat; }).length; }
      tabs.forEach(function(t){ if(count(t.getAttribute('data-cat'))===0){ t.hidden=true; } });
      var visible=tabs.filter(function(t){ return !t.hidden; });
      function activate(cat){
        tabs.forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-cat')===cat); });
        items.forEach(function(it){ it.hidden = !(cat==='all'||it.getAttribute('data-cat')===cat); });
        openFirst();
      }
      tabs.forEach(function(t){ t.addEventListener('click',function(){ activate(t.getAttribute('data-cat')); }); });
      var first = visible.find(function(t){ return t.classList.contains('is-active'); }) || visible[0];
      if(first){ activate(first.getAttribute('data-cat')); }
    } else { openFirst(); }
    function openFirst(){
      if(!list.hasAttribute('data-open-first')) return;
      var vis=items.filter(function(it){ return !it.hidden; });
      items.forEach(function(it){ it.querySelector('.ksiazka-faq__q').setAttribute('aria-expanded','false'); });
      if(vis[0]){ vis[0].querySelector('.ksiazka-faq__q').setAttribute('aria-expanded','true'); }
    }
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-faq]').forEach(initFaq); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-opinie-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function perView(){ var w=window.innerWidth; if(w>=1080)return 3; if(w>=760)return 2; return 1; }
  function initOS(el){
    if(el.dataset.ksReady) return; el.dataset.ksReady='1';
    var track=el.querySelector('[data-ks-track]');
    var slides=track?track.children:[];
    var n=slides.length; if(!n)return;
    var prev=el.parentElement.querySelector('[data-ks-prev]')||document.querySelector('[data-ks-prev]');
    var next=el.parentElement.querySelector('[data-ks-next]')||document.querySelector('[data-ks-next]');
    var section=el.closest('.ksiazka-os');
    if(section){ prev=section.querySelector('[data-ks-prev]'); next=section.querySelector('[data-ks-next]'); }
    var dotsWrap=el.querySelector('[data-ks-dots]');
    var i=0, pv=perView(), pages=Math.max(1, n-pv+1), dots=[];
    function buildDots(){
      if(!dotsWrap)return; dotsWrap.innerHTML=''; dots=[];
      var count=Math.max(1, n-pv+1);
      for(var k=0;k<count;k++){(function(k){
        var b=document.createElement('button'); b.className='ksiazka-os__dot'+(k===0?' is-active':'');
        b.setAttribute('aria-label','Opinia '+(k+1)); b.addEventListener('click',function(){ go(k); });
        dotsWrap.appendChild(b); dots.push(b);
      })(k);}
    }
    function go(x){
      pv=perView(); pages=Math.max(1,n-pv+1);
      i=Math.max(0,Math.min(pages-1,x));
      var slideW=100/pv;
      track.style.transform='translateX(-'+(i*slideW)+'%)';
      dots.forEach(function(d,di){ d.classList.toggle('is-active',di===i); });
      if(prev)prev.disabled=i===0;
      if(next)next.disabled=i>=pages-1;
    }
    if(prev)prev.addEventListener('click',function(){ go(i-1); });
    if(next)next.addEventListener('click',function(){ go(i+1); });
    var x0=null;
    el.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    el.addEventListener('touchend',function(e){ if(x0===null)return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40){ go(dx<0?i+1:i-1); } x0=null; });
    var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(function(){ buildDots(); go(0); },160); });
    buildDots(); go(0);
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-oslider]').forEach(initOS); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-opinie"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviews(list){
    if(list.dataset.ksReady) return; list.dataset.ksReady='1';
    var section=list.closest('.ksiazka-rw');
    var btn=section?section.querySelector('[data-ksiazka-more]'):null;
    if(!btn) return;
    btn.addEventListener('click',function(){
      list.querySelectorAll('.ksiazka-rw__card.is-extra[hidden]').forEach(function(c){ c.hidden=false; });
      btn.remove();
    });
  }
  function initAll(scope){ (scope||document).querySelectorAll('[data-ksiazka-reviews]').forEach(initReviews); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-podglad"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initV(el){
    if(el.dataset.ksReady) return; el.dataset.ksReady='1';
    var btn=el.querySelector('.ksiazka-pv__play');
    var v=el.querySelector('video');
    if(!btn||!v) return;
    btn.addEventListener('click',function(){
      v.setAttribute('controls','');
      el.classList.add('is-playing');
      var p=v.play(); if(p&&p.catch){ p.catch(function(){}); }
    });
  }
  function initAll(s){ (s||document).querySelectorAll('[data-ksiazka-video]').forEach(initV); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksiazka-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function initGallery(g){
    if(g.dataset.ksReady) return; g.dataset.ksReady='1';
    var slides = g.querySelectorAll('.ksiazka-gal__slide');
    var thumbs = g.querySelectorAll('.ksiazka-gal__thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-index');
        slides.forEach(function(s){ s.classList.toggle('is-active', s.getAttribute('data-index')===i); });
        thumbs.forEach(function(x){ var a=x===t; x.classList.toggle('is-active', a); x.setAttribute('aria-selected', a?'true':'false'); });
      });
    });
  }

  function initAcc(a){
    if(a.dataset.ksReady) return; a.dataset.ksReady='1';
    a.querySelectorAll('.ksiazka-acc__head').forEach(function(h){
      h.addEventListener('click', function(){
        var open = h.getAttribute('aria-expanded')==='true';
        h.setAttribute('aria-expanded', open?'false':'true');
      });
    });
  }

  function openDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer){ window.location.href = root() + 'cart'; return; }
    try{
      if(typeof drawer.open === 'function'){ drawer.open(); }
      else { drawer.classList.remove('is-empty'); drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
    }catch(e){ drawer.classList.add('animate','active'); document.body.classList.add('overflow-hidden'); }
  }

  function refreshDrawer(){
    var wrap = document.getElementById('shopify-section-cart-drawer');
    return fetch(root() + '?section_id=cart-drawer', {headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){ if(wrap){ wrap.innerHTML = html; } })
      .then(function(){
        return fetch(root() + '?section_id=cart-icon-bubble').then(function(r){return r.text();}).then(function(h){
          var bubble = document.getElementById('shopify-section-cart-icon-bubble');
          if(bubble){ bubble.innerHTML = h; }
        }).catch(function(){});
      }).catch(function(){});
  }

  function initAtc(form){
    if(form.dataset.ksReady) return; form.dataset.ksReady='1';
    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-ksiazka-atc-err]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(err){ err.hidden=true; err.textContent=''; }
      if(btn){ btn.classList.add('is-loading'); btn.disabled=true; }
      fetch(form.getAttribute('action'), {
        method:'POST',
        headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:new FormData(form)
      })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
      .then(function(res){
        if(!res.ok){ if(err){ err.hidden=false; err.textContent=(res.body&&res.body.description)||'Nie udało się dodać do koszyka.'; } return; }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function(){ if(err){ err.hidden=false; err.textContent='Wystąpił błąd sieci. Spróbuj ponownie.'; } })
      .finally(function(){ if(btn){ btn.classList.remove('is-loading'); btn.disabled=false; } });
    });
  }

  function initAll(scope){
    var s = scope || document;
    s.querySelectorAll('[data-ksiazka-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-ksiazka-acc]').forEach(initAcc);
    s.querySelectorAll('[data-ksiazka-atc]').forEach(initAtc);
  }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
